<template>
  <div class="portrait-container">
    <!-- 左上角装饰图片 -->
    <div class="top-left-decoration">
      <img src="@/assets/leaderboard/top-left.png" alt="装饰图片" />
    </div>

    <!-- 全屏按钮 -->
    <div class="fullscreen-btn" :class="{ 'fullscreen-mode': isFullscreen }" @click="toggleFullscreen">
      <i :class="isFullscreen ? 'el-icon-copy-document' : 'el-icon-full-screen'"></i>
    </div>

    <!-- 屏幕容器 -->
    <div class="screen-container"
         @wheel="handleWheel"
         @touchstart="handleTouchStart"
         @touchmove="handleTouchMove"
         @touchend="handleTouchEnd">
      <div class="screens-wrapper" :class="{ 'no-transition': isScreenResetting }" :style="{ transform: `translateY(${-(currentScreen + 1) * (100/totalRealScreens)}%)` }">
        <!-- 循环副本 - 顶部: 目标达成率 周榜 (向上无缝循环副本) -->
        <div class="screen screen-leaderboards">
          <div class="title-section">
            <div class="title-container">
              <h1 class="title-text">战队龙虎榜</h1>
              <span class="screen-indicator">目标达成率 - 周榜</span>
            </div>
          </div>
          <div class="leaderboards-vertical">
            <div class="leaderboard-item">
              <DashboardCard
                :title="`周榜业绩团队 ${currentWeekRange.start}-${currentWeekRange.end}`"
                :headers="weeklyTeamDataByRate.headers"
                :rows="weeklyTeamDataByRate.rows"
                :mode="'portrait'"
              />
            </div>
            <div class="leaderboard-item">
              <DashboardCard
                :title="`周榜业绩个人 ${currentWeekRange.start}-${currentWeekRange.end}`"
                :headers="weeklyIndividualDataByRate.headers"
                :rows="weeklyIndividualDataByRate.rows"
                :mode="'portrait'"
              />
            </div>
          </div>
        </div>

        <!-- 第一屏: 日榜排行榜 -->
        <div class="screen screen-ranking">
          <RankCard :mode="'portrait'" />
        </div>

        <!-- 第二屏: 下单金额 月榜 -->
        <div class="screen screen-leaderboards">
          <div class="title-section">
            <div class="title-container">
              <h1 class="title-text">战队龙虎榜</h1>
              <span class="screen-indicator">下单金额 - 月榜</span>
            </div>
          </div>
          <div class="leaderboards-vertical">
            <div class="leaderboard-item">
              <DashboardCard
                :title="`${currentMonth.format('M')}月榜业绩团队`"
                :headers="monthlyTeamDataByAmount.headers"
                :rows="monthlyTeamDataByAmount.rows"
                :mode="'portrait'"
              />
            </div>
            <div class="leaderboard-item">
              <DashboardCard
                :title="`${currentMonth.format('M')}月榜业绩个人`"
                :headers="monthlyIndividualDataByAmount.headers"
                :rows="monthlyIndividualDataByAmount.rows"
                :mode="'portrait'"
              />
            </div>
          </div>
        </div>

        <!-- 第三屏: 下单金额 周榜 -->
        <div class="screen screen-leaderboards">
          <div class="title-section">
            <div class="title-container">
              <h1 class="title-text">战队龙虎榜</h1>
              <span class="screen-indicator">下单金额 - 周榜</span>
            </div>
          </div>
          <div class="leaderboards-vertical">
            <div class="leaderboard-item">
              <DashboardCard
                :title="`周榜业绩团队 ${currentWeekRange.start}-${currentWeekRange.end}`"
                :headers="weeklyTeamDataByAmount.headers"
                :rows="weeklyTeamDataByAmount.rows"
                :mode="'portrait'"
              />
            </div>
            <div class="leaderboard-item">
              <DashboardCard
                :title="`周榜业绩个人 ${currentWeekRange.start}-${currentWeekRange.end}`"
                :headers="weeklyIndividualDataByAmount.headers"
                :rows="weeklyIndividualDataByAmount.rows"
                :mode="'portrait'"
              />
            </div>
          </div>
        </div>

        <!-- 第四屏: 目标达成率 月榜 -->
        <div class="screen screen-leaderboards">
          <div class="title-section">
            <div class="title-container">
              <h1 class="title-text">战队龙虎榜</h1>
              <span class="screen-indicator">目标达成率 - 月榜</span>
            </div>
          </div>
          <div class="leaderboards-vertical">
            <div class="leaderboard-item">
              <DashboardCard
                :title="`${currentMonth.format('M')}月榜业绩团队`"
                :headers="monthlyTeamDataByRate.headers"
                :rows="monthlyTeamDataByRate.rows"
                :mode="'portrait'"
              />
            </div>
            <div class="leaderboard-item">
              <DashboardCard
                :title="`${currentMonth.format('M')}月榜业绩个人`"
                :headers="monthlyIndividualDataByRate.headers"
                :rows="monthlyIndividualDataByRate.rows"
                :mode="'portrait'"
              />
            </div>
          </div>
        </div>

        <!-- 第五屏: 目标达成率 周榜 -->
        <div class="screen screen-leaderboards">
          <div class="title-section">
            <div class="title-container">
              <h1 class="title-text">战队龙虎榜</h1>
              <span class="screen-indicator">目标达成率 - 周榜</span>
            </div>
          </div>
          <div class="leaderboards-vertical">
            <div class="leaderboard-item">
              <DashboardCard
                :title="`周榜业绩团队 ${currentWeekRange.start}-${currentWeekRange.end}`"
                :headers="weeklyTeamDataByRate.headers"
                :rows="weeklyTeamDataByRate.rows"
                :mode="'portrait'"
              />
            </div>
            <div class="leaderboard-item">
              <DashboardCard
                :title="`周榜业绩个人 ${currentWeekRange.start}-${currentWeekRange.end}`"
                :headers="weeklyIndividualDataByRate.headers"
                :rows="weeklyIndividualDataByRate.rows"
                :mode="'portrait'"
              />
            </div>
          </div>
        </div>

        <!-- 循环副本 - 末尾: 日榜排行榜 (向下无缝循环副本) -->
        <div class="screen screen-ranking">
          <RankCard :mode="'portrait'" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import RankCard from './components/rank.vue'
import DashboardCard from './components/card.vue'

@Component({
  components: {
    RankCard,
    DashboardCard
  }
})
export default class PortraitComponent extends Vue {
  @Prop({ required: true }) leaderboardData
  @Prop({ required: true }) currentMonth
  @Prop({ required: true }) currentWeekRange
  @Prop({ required: true }) weeklyTeamDataByAmount
  @Prop({ required: true }) monthlyTeamDataByAmount
  @Prop({ required: true }) weeklyIndividualDataByAmount
  @Prop({ required: true }) monthlyIndividualDataByAmount
  @Prop({ required: true }) weeklyTeamDataByRate
  @Prop({ required: true }) monthlyTeamDataByRate
  @Prop({ required: true }) weeklyIndividualDataByRate
  @Prop({ required: true }) monthlyIndividualDataByRate
  @Prop({ required: true }) autoScrollInterval

  currentScreen = 0 // 当前屏幕：0-日榜，1-下单金额月榜，2-下单金额周榜，3-目标达成率月榜，4-目标达成率周榜
  totalScreens = 5 // 真实屏幕数
  totalRealScreens = 7 // 包含循环副本的总屏幕数
  isFullscreen = false
  isTransitioning = false
  isScreenResetting = false // 是否正在重置屏幕位置
  autoScrollTimer = null // 自动切换定时器

  // 鼠标滚轮相关
  wheelThrottleTimer = null // 滚轮防抖定时器
  lastWheelTime = 0 // 上次滚轮事件时间

  // 触摸相关
  touchStartY = 0 // 触摸开始的Y坐标
  touchEndY = 0 // 触摸结束的Y坐标
  touchStartTime = 0 // 触摸开始时间
  minSwipeDistance = 50 // 最小滑动距离（像素）
  maxSwipeTime = 1000 // 最大滑动时间（毫秒）

  // 通用状态
  lastInteractionTime = 0 // 上次交互时间
  resumeAutoScrollTimer = null // 恢复自动滚动的定时器

  getScreenTitle() {
    const titles = {
      0: '日榜开单王',
      1: '下单金额 - 月榜',
      2: '下单金额 - 周榜',
      3: '目标达成率 - 月榜',
      4: '目标达成率 - 周榜'
    }
    return titles[this.currentScreen] || ''
  }


  switchToNextScreen() {
    if (this.isTransitioning) return

    this.isTransitioning = true
    this.stopAutoScrollTimer() // 停止自动切换

    // 正常切换到下一个位置
    this.currentScreen++

    // 如果切换到了向下循环副本（第5个位置），等待动画完成后瞬间重置
    if (this.currentScreen === this.totalScreens) {
      setTimeout(() => {
        // 找到屏幕容器元素
        const wrapper = this.$el.querySelector('.screens-wrapper')

        // 禁用CSS动画
        this.isScreenResetting = true
        wrapper.style.transition = 'none'

        // 重置位置到第一屏
        this.currentScreen = 0
        wrapper.style.transform = `translateY(${-(this.currentScreen + 1) * (100 / this.totalRealScreens)}%)`

        // 强制浏览器重绘
        wrapper.offsetHeight

        // 延迟后重新启用动画
        setTimeout(() => {
          this.isScreenResetting = false
          wrapper.style.transition = ''
        }, 50)
      }, 400) // 等待切换到循环副本的动画完成
    }

    setTimeout(() => {
      this.isTransitioning = false
      this.startAutoScrollTimer() // 重新启动自动切换
    }, 400)
  }

  switchToPrevScreen() {
    if (this.isTransitioning) return

    this.isTransitioning = true
    this.stopAutoScrollTimer() // 停止自动切换

    // 正常切换到上一个位置
    this.currentScreen--

    // 如果切换到了向上循环副本（第-1个位置），等待动画完成后瞬间重置
    if (this.currentScreen === -1) {
      setTimeout(() => {
        // 找到屏幕容器元素
        const wrapper = this.$el.querySelector('.screens-wrapper')

        // 禁用CSS动画
        this.isScreenResetting = true
        wrapper.style.transition = 'none'

        // 重置位置到最后一屏
        this.currentScreen = this.totalScreens - 1
        wrapper.style.transform = `translateY(${-(this.currentScreen + 1) * (100 / this.totalRealScreens)}%)`

        // 强制浏览器重绘
        wrapper.offsetHeight

        // 延迟后重新启用动画
        setTimeout(() => {
          this.isScreenResetting = false
          wrapper.style.transition = ''
        }, 50)
      }, 400) // 等待切换到循环副本的动画完成
    }

    setTimeout(() => {
      this.isTransitioning = false
      this.startAutoScrollTimer() // 重新启动自动切换
    }, 400)
  }

  // 启动自动切换
  startAutoScrollTimer() {
    this.stopAutoScrollTimer() // 先停止已有的定时器
    this.autoScrollTimer = setInterval(() => {
      this.switchToNextScreen()
    }, this.autoScrollInterval * 1000) // 使用配置的间隔时间（秒转毫秒）
  }

  // 停止自动切换
  stopAutoScrollTimer() {
    if (this.autoScrollTimer) {
      clearInterval(this.autoScrollTimer)
      this.autoScrollTimer = null
    }
  }


  // 统一的用户交互处理
  handleUserInteraction() {
    this.lastInteractionTime = Date.now()
    this.stopAutoScrollTimer()

    // 清除之前的恢复定时器
    if (this.resumeAutoScrollTimer) {
      clearTimeout(this.resumeAutoScrollTimer)
    }

    // 5秒后恢复自动滚动
    this.resumeAutoScrollTimer = setTimeout(() => {
      this.startAutoScrollTimer()
    }, 5000)
  }

  handleKeydown(event) {
    if (event.key === 'ArrowUp') {
      event.preventDefault()
      this.handleUserInteraction()
      this.switchToPrevScreen()
    } else if (event.key === 'ArrowDown') {
      event.preventDefault()
      this.handleUserInteraction()
      this.switchToNextScreen()
    } else if (event.key === 'Escape' && this.isFullscreen) {
      event.preventDefault()
      this.exitFullscreen()
    }
  }

  // 鼠标滚轮事件处理
  handleWheel(event) {
    event.preventDefault()

    // 防抖处理：如果正在过渡或重置中，忽略滚轮事件
    if (this.isTransitioning || this.isScreenResetting) {
      return
    }

    const now = Date.now()

    // 滚轮节流：限制触发频率（300ms内只允许一次）
    if (now - this.lastWheelTime < 300) {
      return
    }

    this.lastWheelTime = now
    this.handleUserInteraction()

    // 判断滚动方向（增加敏感度阈值）
    const deltaY = event.deltaY
    if (Math.abs(deltaY) > 10) { // 最小滚动阈值
      if (deltaY > 0) {
        // 向下滚动
        this.switchToNextScreen()
      } else {
        // 向上滚动
        this.switchToPrevScreen()
      }
    }
  }

  // 触摸开始事件处理
  handleTouchStart(event) {
    // 阻止默认行为（如页面滚动）
    event.preventDefault()

    // 如果正在过渡或重置中，忽略触摸事件
    if (this.isTransitioning || this.isScreenResetting) {
      return
    }

    // 记录触摸开始位置和时间
    const touch = event.touches[0]
    this.touchStartY = touch.clientY
    this.touchStartTime = Date.now()
  }

  // 触摸移动事件处理（阻止页面滚动）
  handleTouchMove(event) {
    // 阻止默认行为（如页面滚动）
    event.preventDefault()
  }

  // 触摸结束事件处理
  handleTouchEnd(event) {
    // 阻止默认行为
    event.preventDefault()

    // 如果正在过渡或重置中，忽略触摸事件
    if (this.isTransitioning || this.isScreenResetting) {
      return
    }

    // 记录触摸结束位置和时间
    const touch = event.changedTouches[0]
    this.touchEndY = touch.clientY
    const touchEndTime = Date.now()

    // 计算滑动距离、时间和速度
    const swipeDistance = this.touchStartY - this.touchEndY
    const absSwipeDistance = Math.abs(swipeDistance)
    const swipeTime = touchEndTime - this.touchStartTime
    const swipeVelocity = absSwipeDistance / swipeTime // 像素/毫秒

    // 触发条件：滑动距离足够 且 时间合理 且 速度不能太慢
    const isValidSwipe = absSwipeDistance >= this.minSwipeDistance &&
                        swipeTime <= this.maxSwipeTime &&
                        swipeVelocity > 0.1 // 最小速度阈值

    if (isValidSwipe) {
      this.handleUserInteraction()

      if (swipeDistance > 0) {
        // 向上滑动（手指从下往上移动），切换到下一屏
        this.switchToNextScreen()
      } else {
        // 向下滑动（手指从上往下移动），切换到上一屏
        this.switchToPrevScreen()
      }
    }
  }

  async toggleFullscreen() {
    if (!this.isFullscreen) {
      await this.enterFullscreen()
    } else {
      await this.exitFullscreen()
    }
  }

  async enterFullscreen() {
    try {
      const element = this.$el
      if (element.requestFullscreen) {
        await element.requestFullscreen()
      } else if (element.mozRequestFullScreen) {
        await element.mozRequestFullScreen()
      } else if (element.webkitRequestFullscreen) {
        await element.webkitRequestFullscreen()
      } else if (element.msRequestFullscreen) {
        await element.msRequestFullscreen()
      }
      this.isFullscreen = true
    } catch (error) {
      console.error('Failed to enter fullscreen:', error)
    }
  }

  async exitFullscreen() {
    try {
      if (document.exitFullscreen) {
        await document.exitFullscreen()
      } else if (document.mozCancelFullScreen) {
        await document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) {
        await document.webkitExitFullscreen()
      } else if (document.msExitFullscreen) {
        await document.msExitFullscreen()
      }
      this.isFullscreen = false
    } catch (error) {
      console.error('Failed to exit fullscreen:', error)
    }
  }

  handleFullscreenChange() {
    this.isFullscreen = !!(
      document.fullscreenElement ||
      document.mozFullScreenElement ||
      document.webkitFullscreenElement ||
      document.msFullscreenElement
    )
  }

  // 监听 autoScrollInterval 变化
  @Watch('autoScrollInterval')
  onAutoScrollIntervalChanged() {
    // 如果定时器正在运行，重新启动以使用新的间隔
    if (this.autoScrollTimer) {
      this.startAutoScrollTimer()
    }
  }

  mounted() {
    document.addEventListener('keydown', this.handleKeydown)
    document.addEventListener('fullscreenchange', this.handleFullscreenChange)
    document.addEventListener('mozfullscreenchange', this.handleFullscreenChange)
    document.addEventListener('webkitfullscreenchange', this.handleFullscreenChange)
    document.addEventListener('msfullscreenchange', this.handleFullscreenChange)

    // 启动自动切换
    this.startAutoScrollTimer()
  }

  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown)
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange)
    document.removeEventListener('mozfullscreenchange', this.handleFullscreenChange)
    document.removeEventListener('webkitfullscreenchange', this.handleFullscreenChange)
    document.removeEventListener('msfullscreenchange', this.handleFullscreenChange)

    // 清除所有定时器
    this.stopAutoScrollTimer()
    if (this.wheelThrottleTimer) {
      clearTimeout(this.wheelThrottleTimer)
      this.wheelThrottleTimer = null
    }
    if (this.resumeAutoScrollTimer) {
      clearTimeout(this.resumeAutoScrollTimer)
      this.resumeAutoScrollTimer = null
    }
  }
}
</script>

<style lang="scss" scoped>
.portrait-container {
  padding: 3vw;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-image: url('~@/assets/leaderboard/bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
  position: relative;

  .top-left-decoration {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    pointer-events: none;
    width: 25%;

    img {
      display: block;
      width: 100%;
      height: auto;
    }
  }

  .fullscreen-btn {
    position: absolute;
    top: 1vw;
    right: 1vw;
    width: 4vh;
    height: 4vh;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #8a5524;
    border-radius: 0.8vh;
    transition: all 0.3s ease;
    background: rgba(255, 255, 255, 0.95);
    box-shadow: 0 0.3vh 1vh rgba(0, 0, 0, 0.15);
    z-index: 1000;
    opacity: 1;

    &:hover {
      transform: scale(1.05);
    }

    &.fullscreen-mode {
      opacity: 0;

      &:hover {
        opacity: 1;
      }
    }

    i {
      font-size: 2.4vh;
    }
  }
}

.title-section {
  text-align: center;
  margin-bottom: 2vh;
  flex-shrink: 0;
  position: relative;
  display: flex;
  justify-content: center;

  .title-container {
    display: inline-flex;
    align-items: baseline;
    gap: 1vh;

    .title-text {
      font-size: 4vh;
      font-weight: 700;
      color: #8a5524;
      margin: 0;
      text-shadow: 0 0.2vh 0.4vh rgba(0, 0, 0, 0.1);
      white-space: nowrap;
    }

    .screen-indicator {
      font-size: 2vh;
      font-weight: 500;
      color: #8a5524;
      opacity: 0.8;
      white-space: nowrap;
      min-width: 6em;
      text-align: left;
    }
  }
}

.screen-container {
  flex: 1;
  min-height: 0;
  position: relative;
  z-index: 10;
  overflow: hidden;

  .screens-wrapper {
    height: 700%; /* 七个屏幕（5个真实屏幕 + 2个循环副本） */
    width: 100%;
    display: flex;
    flex-direction: column;
    transition: transform 0.4s cubic-bezier(0.4, 0.0, 0.2, 1);

    &.no-transition {
      transition: none !important;
    }

    .screen {
      height: 14.286%; /* 每个屏幕占14.286%高度（100%/7） */
      width: 100%;
      display: flex;
      flex-direction: column;
      position: relative;
      flex-shrink: 0;
    }

    .screen-ranking {
      padding: 2vh 0;
      justify-content: center;
      align-items: center;
    }

    .screen-leaderboards {
      padding: 1vh 0;
      overflow: hidden;
      display: flex;
      flex-direction: column;

      .title-section {
        flex-shrink: 0;
        margin-bottom: 2vh;
      }
    }
  }
}


.leaderboards-vertical {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 2vh;

  .leaderboard-item {
    flex: 1;
    min-height: 0;
  }
}

</style>
